import React from 'react';
import { ClockIcon, CalendarIcon, UtensilsIcon } from 'lucide-react';
export function RestaurantSection() {
  return;
}